export default {"src":"/_next/static/media/AssetsWhite.59f082fc.svg","height":34,"width":34};